/* eslint-disable react/button-has-type */
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { makeLangUrl } from "helpers/makeLangUrl";
import UserInfoContainer from "containers/organisms/UserInfoContainer";
import { useGTM } from "hooks/useGTM";
import { useBreakpoint } from "hooks/useBreakpoint";
import GloryLogotype from "assets/icons/glory/logo_big.svg?react";
import BangerLogotype from "assets/icons/banger/logo.svg?react";
import BangerLogoMini from "assets/icons/banger/logo_320.svg?react";
import url from "url/index";
import * as userSelectors from "redux/user/selectors";
import TopNavigationDesktop from "../TopNavigationDesktop";

import "./styles.sass";
import UserControlsNotAuth from "../../molecules/UserControlsNotAuth";

type HeaderProps = {
  isAuthenticated?: boolean | null;
  resetCategory: () => void;
};

const Header = (props: HeaderProps) => {
  const { isAuthenticated, resetCategory } = props;

  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const { isCustomBreakpointSmaller } = useBreakpoint(320);
  const userId = useSelector(userSelectors.id) || 0;
  const navigate = useNavigate();
  const GTM = useGTM();

  const handleLogoClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    GTM.openMainPage(userId);
    resetCategory();
    navigate(makeLangUrl(url.routes.casino.index()));
  };

  const HeaderLogoClass = classNames("Header__logo", {
    // eslint-disable-next-line camelcase
    Header__logo_banger: VITE_APP_PROJECT_NAME === "banger",
  });

  const headerTopClass = classNames("Header__top", {
    auth: isAuthenticated,
  });

  const headerClass = classNames("Header", {
    auth: isAuthenticated,
  });

  let logoBanger = <BangerLogotype />;
  if (isCustomBreakpointSmaller) {
    logoBanger = <BangerLogoMini />;
  }

  return (
    <div className={headerClass}>
      <div className={headerTopClass}>
        <div className={HeaderLogoClass} onClick={handleLogoClick}>
          {VITE_APP_PROJECT_NAME === "banger" ? logoBanger : <GloryLogotype />}
        </div>
        <div className="Header__navigation">
          <TopNavigationDesktop />
        </div>
        <div className="Header__userinfo">
          {!isAuthenticated ? <UserControlsNotAuth /> : <UserInfoContainer />}
          {/* <UserInfoContainer /> */}
        </div>
      </div>
    </div>
  );
};

export default Header;
